import React from 'react'
import styles from './styles.module.scss'
import ActionInput from '../../misc/action-elements/action-input/action-input'
import ActionButton from '../../misc/action-elements/action-button/action-button'
import { Overlay } from '../../helpers/overlays/overlay'
import ItemInfos from '@/src/interfaces/catalog/item-infos'

interface Props {
    onConfirm: (value: number) => void
    initialValue?: number
    wizard: boolean
    maxValue?: number
    sumOfQtyAnswered?: number
    itemGroup?: ItemInfos.ItemGroup
}

export default function ModalAddCustom({ onConfirm, initialValue = 0, wizard, maxValue, sumOfQtyAnswered = 0, itemGroup }: Props) {
    const [selectedValue, setSelectedValue] = React.useState<number>(initialValue === 0 ? (wizard ? 0 : 1) : initialValue)

    const handleConfirm = () => {
        const finalValue = !selectedValue ? (wizard ? 0 : 1) : selectedValue
        onConfirm(finalValue)
        Overlay.dismiss()
    }

    const maxQtyItems = itemGroup?.maxQtyItems
    const isGroupWithMaxQtyAnswers = !!itemGroup?.maxQtyAnswer

    const handleNumberChange = (value: string) => {
        const _value = Number(value)
        const validateValue = _value + sumOfQtyAnswered

        if (maxQtyItems && sumOfQtyAnswered > maxQtyItems) {
            setSelectedValue(maxQtyItems - sumOfQtyAnswered)
            return
        }

        if (maxQtyItems && sumOfQtyAnswered < maxQtyItems) {
            const calc = Math.abs(maxQtyItems - sumOfQtyAnswered) + initialValue

            if (maxValue && calc > maxValue && _value > maxValue)
                setSelectedValue(maxValue)
            else if (_value === maxValue && sumOfQtyAnswered === 0)
                setSelectedValue(_value)
            else if (maxValue && _value > maxValue)
                setSelectedValue(calc)
            else {
                if (_value > calc)
                    setSelectedValue(calc)
                else
                    setSelectedValue(_value)
            }
            return
        }

        if (maxQtyItems && validateValue >= maxQtyItems && initialValue) {
            const calc = Math.abs(validateValue - maxQtyItems)

            if (initialValue < calc)
                setSelectedValue(initialValue)
            else
                setSelectedValue(calc)
            return
        }

        if (maxValue && validateValue > maxValue && isGroupWithMaxQtyAnswers) {
            let newValue = _value - (validateValue - maxValue) + initialValue

            if (newValue < 0)
                newValue = _value

            setSelectedValue(newValue)
            return
        }

        if (!isGroupWithMaxQtyAnswers && maxValue) {
            let newValue = _value

            if (_value > maxValue)
                newValue = maxValue

            setSelectedValue(newValue)
            return
        }

        if (_value <= 0)
            setSelectedValue(0)
        else
            setSelectedValue(_value)
    }

    const renderMax = () => {
        if (maxValue !== undefined && maxValue > 0) {
            let calc = Math.abs(maxValue - sumOfQtyAnswered) + initialValue

            if (maxQtyItems)
                calc = maxQtyItems - sumOfQtyAnswered

            if (calc > maxValue)
                calc = maxValue

            return <small>máx. {calc}</small>
        }
        return <></>
    }

    const handleClose = () => {
        Overlay.dismiss()
    }

    return (
        <div className={styles.modalContainer}>
            <div className={styles.inputArea}>
                <h5 className='font-md'>Selecione a quantidade:</h5>
                {renderMax()}
                <ActionInput
                    placeholder='1'
                    inputMode="numeric"
                    autoFocus
                    value={selectedValue}
                    type='text'
                    pattern="[0-9]*"
                    onChange={e => {
                        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 3)
                        handleNumberChange(value)
                    }}
                    maxLength={3}
                    onKeyDown={e => e.key === 'Enter' && handleConfirm()}
                />
            </div>
            <ActionButton
                onClick={handleConfirm}
                className={styles.btn}
                size='medium'
            >
                Confirmar
            </ActionButton>
            <ActionButton
                onClick={handleClose}
                theme='inverted'
                className={styles.btn}
                size='medium'
            >
                Cancelar
            </ActionButton>
        </div>
    )
}